const ConsumerIcon = ({ isSelect }: { isSelect: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.67 13.02C10.45 13.01 10.23 13 9.99995 13C7.57995 13 5.31995 13.67 3.38995 14.82C2.50995 15.34 1.99995 16.32 1.99995 17.35V20H11.26C10.47 18.87 9.99995 17.49 9.99995 16C9.99995 14.93 10.25 13.93 10.67 13.02Z"
        fill={isSelect}
      />
      <path
        d="M9.99995 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 9.99995 4C7.79082 4 5.99995 5.79086 5.99995 8C5.99995 10.2091 7.79082 12 9.99995 12Z"
        fill={isSelect}
      />
      <path
        d="M20.75 16C20.75 15.78 20.72 15.58 20.69 15.37L21.83 14.36L20.83 12.63L19.38 13.12C19.06 12.85 18.7 12.64 18.3 12.49L18 11H16L15.7 12.49C15.3 12.64 14.94 12.85 14.62 13.12L13.17 12.63L12.17 14.36L13.31 15.37C13.28 15.58 13.25 15.78 13.25 16C13.25 16.22 13.28 16.42 13.31 16.63L12.17 17.64L13.17 19.37L14.62 18.88C14.94 19.15 15.3 19.36 15.7 19.51L16 21H18L18.3 19.51C18.7 19.36 19.06 19.15 19.38 18.88L20.83 19.37L21.83 17.64L20.69 16.63C20.72 16.42 20.75 16.22 20.75 16ZM17 18C15.9 18 15 17.1 15 16C15 14.9 15.9 14 17 14C18.1 14 19 14.9 19 16C19 17.1 18.1 18 17 18Z"
        fill={isSelect}
      />
    </svg>
  );
};

export default ConsumerIcon;
